import styled from 'styled-components';

interface T2Props {
	'data-test-id'?: string;
}

const T2 = styled.p<T2Props>`
	font-weight: normal;
	font-size: 1.1rem;
	line-height: 170%;
	letter-spacing: 0.5px;
	margin-bottom: 14px;
	font-style: normal;
	color: black;
`;

export default T2;
